import { useParams, Navigate } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { InquiryForm } from '../components/ui/InquiryForm';
import { CTAButton } from '../components/ui/CTAButton';
import { RelatedLinks } from '../components/ui/RelatedLinks';
import { getContactType } from '../constants/content';
import { contactPath, inquiryPath } from '../constants/navigation';

export default function ContactDetailPage() {
  const { type } = useParams();
  const contact = getContactType(type);

  if (!contact) {
    return <Navigate to="/contact" replace />;
  }

  return (
    <>
      <PageHero
        title={contact.title}
        subtitle={contact.summary}
        breadcrumb={[
          { label: '首页', path: '/' },
          { label: '联系我们', path: '/contact' },
          { label: contact.title },
        ]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
          <div className="lg:col-span-2 space-y-8">
            <AnimatedCard className="bg-white/5 rounded-2xl p-8 border border-purple-500/20">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-14 h-14 rounded-2xl bg-secondary/20 flex items-center justify-center">
                  <i className={`fa ${contact.icon} text-secondary text-2xl`} />
                </div>
                <div>
                  <h2 className="text-xl font-bold">{contact.title}</h2>
                  <p className="text-purple-300 text-sm">{contact.desc}</p>
                </div>
              </div>

              <h3 className="font-semibold text-secondary mb-4">合作 / 咨询范围</h3>
              <ul className="space-y-3 mb-8">
                {contact.details.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-purple-200 text-sm">
                    <i className="fa fa-angle-right text-secondary mt-0.5" />
                    {item}
                  </li>
                ))}
              </ul>

              {type === 'gift' && (
                <div className="bg-primary/10 rounded-xl p-4 mb-8 border border-purple-500/20">
                  <p className="text-purple-200 text-sm mb-3">
                    <i className="fa fa-info-circle text-secondary mr-2" />
                    礼品采购也可直接前往购买咨询页面选择具体产品并提交意向。
                  </p>
                  <CTAButton to={inquiryPath()} variant="secondary" size="sm" icon="fa-shopping-cart">
                    前往购买咨询
                  </CTAButton>
                </div>
              )}

              <h3 className="font-semibold text-secondary mb-4">对接流程</h3>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-8">
                {contact.process.map((step, i) => (
                  <div
                    key={step}
                    className="bg-darker/40 rounded-xl p-3 text-center border border-purple-500/10"
                  >
                    <span className="text-purple-400 text-xs">{i + 1}</span>
                    <p className="text-purple-200 text-xs mt-1">{step}</p>
                  </div>
                ))}
              </div>
            </AnimatedCard>

            <AnimatedCard className="bg-white/5 rounded-2xl p-8 border border-purple-500/20">
              <h2 className="text-xl font-bold mb-6">在线提交</h2>
              <InquiryForm
                subject={contact.subject}
                showProductField={type === 'gift'}
              />
            </AnimatedCard>
          </div>

          <div className="space-y-6">
            <RelatedLinks
              title="其他联系方式"
              links={[
                { to: '/contact', label: '联系首页' },
                ...(type !== 'business'
                  ? [{ to: contactPath('business'), label: '商务合作' }]
                  : []),
                ...(type !== 'feedback'
                  ? [{ to: contactPath('feedback'), label: '产品反馈' }]
                  : []),
                ...(type !== 'gift'
                  ? [{ to: contactPath('gift'), label: '礼品采购' }]
                  : []),
                { to: inquiryPath(), label: '购买咨询' },
                { to: '/support', label: '技术支持' },
              ]}
            />
            <div className="bg-gradient-to-br from-primary/20 to-secondary/20 rounded-2xl p-6 border border-purple-500/20 text-center">
              <i className="fa fa-clock-o text-secondary text-2xl mb-3" />
              <p className="text-purple-200 text-sm">工作日 1-2 个工作日内回复</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
